import css from '@emotion/css';
import styled from '@emotion/styled';
import { borderRadii, layers } from 'app/spacing';

export const OptionPlaceholder = styled.div`
  height: ${({ cardHeight }) => cardHeight}px;
  ${({ cardWidth }) =>
    cardWidth
      ? css`
          width: calc(${cardWidth} - ${cardWidth === '100%' ? 0 : 5}px);
        `
      : ''}
  margin: 7.5px 0 7.5px 0;

  background-color: var(--color-background-light);
  border: 1px dashed var(--color-border-medium);
  border-radius: ${borderRadii.standard};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 10px;
`;

export const DragItemWrapper = styled.div`
  position: relative;
  ${({ width }) => {
    return width === 100 || !width
      ? css`
          width: 100%;
        `
      : css`
          flex: 0 0 calc(${width}% - 5px);
        `;
  }}
  ${({ dragging, draggingFrom, optioning, editing }) =>
    dragging || draggingFrom || optioning || editing
      ? css`
          z-index: ${layers.content(0, 4)};
        `
      : css`
          z-index: 0;
        `}
  ${({ dragging, draggingDimensions }) =>
    dragging &&
    draggingDimensions &&
    css`
      position: fixed;
      pointer-events: none;
      z-index: ${layers.content(99)};
      & * {
        pointer-events: none;
      }

      ${css(draggingDimensions)}
    `}

  ${({ isChildDragging }) =>
    isChildDragging
      ? css`
          z-index: ${layers.content(99)};
        `
      : ''}

      & .innerItem {
    height: 44px;
  }
`;

export const StyledGroupTitle = styled.div`
  margin-top: ${({ index }) => (index ? 6 : 8)}px;
  margin-left: -1px;
  > div {
    padding-top: 12px;
    padding-left: 1px;
  }
`;
